// 事前生成音声のキー (spec: docs/superpowers/specs/2026-07-26-prerendered-tts-design.md §5)。
//
// crypto.subtle は Node 20+ にも globalThis にあるため、ブラウザ (実行時の照会) と
// ビルドスクリプト (生成時のファイル名) で同じ実装を共有する。別実装にすると
// 桁の丸めや文字コードの扱いがズレて全件キャッシュミスになりうる。
//
// voiceId / model をキーに含めるので、voice を変えると全ハッシュが変わり
// 録り直しが必要になる。これは意図した挙動 (声が変われば全部録り直すべき)。
export async function ttsAssetKey(text: string, voiceId: string, model: string): Promise<string> {
  const input = `${text}|${voiceId}|${model}`;
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(input));
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("")
    .slice(0, 16);
}
